exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1H45OoU4WkJM8i{margin:0 0 8px}._1LawENaF54c6N4{border-radius:4px;border:1px solid #c1c7d0;width:100%}", ""]);

// exports
exports.locals = {
	"detailsList": "_1H45OoU4WkJM8i",
	"image": "_1LawENaF54c6N4"
};